module.exports = __webpack_public_path__ + "static/example_1-1f760f9aa07b4e67fb94c4d0c62bff38.jpg";